import EmptySec from "./EmptySec";
import FooterSec from "./FooterSec";
import HowIWork from "./HowIWorkSec";
import ReviewSec from "./ReviewSec";
import ToolsSec from "./ToolsSec";

export default function Segment4(){
    return(
    <div className="seg4">
         <ToolsSec/>
        <HowIWork/>
        <ReviewSec/>
        <FooterSec/>
    </div>
    )
}